import { AppId, PAGE_MIGRATION_URL_PREFIX, createPageRoute } from '@lumapps/router';

export const searchRoute = createPageRoute({
    slug: `${PAGE_MIGRATION_URL_PREFIX}/search/:query`,
    appId: AppId.frontOffice,
    useRawSlug: true,
});
